import { rootMargin } from '@helpers/animation';
import { formatPageCount } from '@helpers/utils';
import { withQueryParams } from '@hoc/withQueryParams';
import { useApi } from '@hooks/useApi';
import { useInView } from '@hooks/useInView';
import Pagination from '@stories/Components/Global/Pagination/Pagination';
import ScrollLoader from '@stories/Components/Global/ScrollLoader/ScrollLoader';
import HorizontalFormSection from '@stories/Components/HorizontalForm/HorizontalFormSection';
import OfferDetailCard from '@stories/Components/OfferDetailCard/OfferDetailCard';
import * as React from 'react';
import { useState } from 'react';
import { NumberParam, StringParam, useQueryParams } from 'use-query-params';
import S from './OfferListing.styles';
const OfferListing = ({ initialData, initialMake, initialOfferType, ...props }) => {
    const [inViewRef, active] = useInView({
        rootMargin,
    });
    const [params, setParams] = useQueryParams({
        offerType: StringParam,
        pageIndex: NumberParam,
        pageSize: NumberParam,
        make: StringParam,
    });
    const makeValue = params.make ?? initialMake ?? '';
    const offerType = params.offerType ?? initialOfferType ?? '';
    const pageIndex = params.pageIndex ?? 1;
    const pageSize = params.pageSize ?? 12;
    const { data, loading } = useApi(`/api/get-offers`, initialData, {
        offerType,
        pageIndex,
        pageSize,
        make: makeValue,
    });
    const [make, setMake] = useState(makeValue);
    return (React.createElement(S.Container, { id: props.id, ref: inViewRef, flush: "top", spacing: "padding" },
        React.createElement(S.Filters, { action: data.makeOptions.find((x) => x.value === make)?.link, method: "GET" },
            React.createElement(S.FiltersContainer, null,
                React.createElement(HorizontalFormSection, { title: "Type", inputId: "type" },
                    React.createElement(S.Select, { id: "type", name: 'offerType', "data-has-value": !!offerType, value: offerType, onChange: (e) => {
                            setParams({ pageIndex: 1, offerType: e.currentTarget.value }, 'pushIn');
                        } },
                        React.createElement("option", { value: "" }, "Select an offer type..."),
                        data.offerTypeOptions.map((option) => (React.createElement("option", { disabled: option.disabled, key: option.value, value: option.value }, option.text))))),
                React.createElement(HorizontalFormSection, { title: "Make", inputId: "make" },
                    React.createElement(S.Select, { id: "make", name: 'make', disabled: !!initialMake, "data-has-value": !!make, value: data.makeOptions.find((x) => x.value === make)?.value, onChange: (e) => {
                            setParams({ pageIndex: 1, make: e.currentTarget.value }, 'pushIn');
                            setMake(e.currentTarget.value);
                        } },
                        React.createElement("option", { value: "" }, "Select a make..."),
                        data.makeOptions.map((option) => (React.createElement("option", { disabled: option.disabled, key: option.value, value: option.value }, option.text))))))),
        React.createElement(S.TopBar, null,
            React.createElement(S.PageCount, null, formatPageCount(pageIndex, pageSize, data.totalItems)),
            React.createElement(S.PageSize, null,
                React.createElement(S.FilterLabel, { htmlFor: "pageSize" }, "Items per page"),
                React.createElement(S.FilterSelect, { name: "pageSize", id: "pageSize", value: pageSize, onChange: (event) => {
                        setParams({ pageIndex: 1, pageSize: parseInt(event.target.value, 10) }, 'pushIn');
                    } },
                    React.createElement("option", { value: "12" }, "Show 12"),
                    React.createElement("option", { value: "24" }, "Show 24"),
                    React.createElement("option", { value: "48" }, "Show 48")))),
        React.createElement(S.ItemList, null, data.items.map((item, index) => (React.createElement(S.Item, { key: item.id },
            React.createElement(OfferDetailCard, { ...item, visible: active, index: index }))))),
        React.createElement(S.BottomBar, null,
            React.createElement(Pagination, { pageIndex: pageIndex, pageSize: pageSize, totalCount: data.totalItems, onPageIndexChange: (pageIndex) => {
                    setParams({ pageIndex: pageIndex }, 'pushIn');
                    setTimeout(() => inViewRef.current?.scrollIntoView({
                        behavior: 'smooth',
                        block: 'start',
                        inline: 'start',
                    }), 50);
                } })),
        React.createElement(ScrollLoader, { loading: loading })));
};
export default withQueryParams(OfferListing);
